import React from 'react';
import PropTypes from 'prop-types';
import IconSvg from "./IconSvg";

class Loading extends React.Component {
    static propTypes = {
        inline: PropTypes.bool,
        small: PropTypes.bool,
    };

    render() {
        const {inline, small} = this.props;

        let classes = "spinner spinner-active";
        if (inline) {
            classes += " spinner-inline";
        }

        if (small) {
            classes += " spinner-small";
        }

        return (
            <span className={classes}>
                <IconSvg id='spinner'/>
            </span>
        )
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading.jsx